import { useState, useEffect } from 'react';
import { lessonAPI } from '../utils/api';
import { LessonHistoryEntry } from '../types/history';

interface UseLessonHistoryReturn {
  lessons: LessonHistoryEntry[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useLessonHistory(): UseLessonHistoryReturn {
  const [lessons, setLessons] = useState<LessonHistoryEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await lessonAPI.getLessonHistory();
      
      // Validate response
      if (Array.isArray(data)) {
        setLessons(data);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (err) {
      console.error('Failed to fetch lesson history:', err);
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { 
    lessons, 
    loading, 
    error, 
    refetch: fetchData 
  };
}